import React from "react";
import {Route, Routes} from "react-router-dom";
import {PageLoader} from "./components/PageLoader";
import {AuthenticationGuard} from "./components/AuthenticationGuard";
import {CallbackPage} from "./pages/CallbackPage";
import {HomePage} from "./pages/HomePage";
import {NotFoundPage} from "./pages/NotFoundPage";
import Dashboard from "./pages/Dashboard";
import SubscriptionSuccess from "./pages/SubscriptionSuccess";
import SubscriptionCancel from "./pages/SubscriptionCancel";
import Pricing from "./pages/Pricing";
import {useUserData} from "./hooks/useUserData";
import {useAuth0} from "@auth0/auth0-react";
import {ROUTES} from "./config/routes";

export const App = () => {
    const {isLoading: auth0Loading} = useAuth0();
    const {isLoading: userDataLoading} = useUserData();

    // Show loader until Auth0 is fully initialized
    // This prevents flash of header/nav before Auth0 is ready
    if (auth0Loading || userDataLoading) {
        return (
            <div className="page-layout">
                <PageLoader/>
            </div>
        );
    }

    return (
        <Routes>
            <Route path={ROUTES.HOME} element={<HomePage/>}/>
            <Route path={ROUTES.DASHBOARD} element={<AuthenticationGuard component={Dashboard}/>}/>
            <Route path={ROUTES.CALLBACK} element={<CallbackPage/>}/>
            <Route path={ROUTES.SUBSCRIPTION_SUCCESS} element={<SubscriptionSuccess/>}/>
            <Route path={ROUTES.SUBSCRIPTION_CANCEL} element={<AuthenticationGuard component={SubscriptionCancel}/>}/>
            <Route path={ROUTES.PRICING} element={<AuthenticationGuard component={Pricing}/>}/>
            <Route path={ROUTES.NOT_FOUND} element={<NotFoundPage/>}/>
        </Routes>
    );
};
